/* 
// ///////////////
// Fine name: adsConfigurations.js
// Description: // This file contains all the data and configs related to Ads 
// ///////////////
*/

import googleIcon from "assets/images/Google ads icone.png";
import metaIcon from "assets/images/Meta icone.png";
import shopifyIcon from "assets/images/shopify-logo.png";
import tiktokIcon from "assets/images/tictok_icon.png";
import snapchatIcon from "assets/images/snapchat_icon.png";
import linkedinIcon from "assets/images/linkedin_icon.png";
import taboolaIcon from "assets/images/taboola_icon.svg";

const BASE_URL = process.env.REACT_APP_API_URL;

export const platformDetailsData = [
  {
    name: "Google Ads",
    slug: "google",
    icon: googleIcon,
    description: `Google Ads is an online advertising platform developed by Google, where advertisers bid to display brief a
                  dvertisements, service offerings, product listings, or videos to web users.`,
    isConnected: false,
    tagline: "PREMIUM",
  },
  {
    name: "Meta Ads",
    slug: "meta",
    icon: metaIcon,
    description: `Meta Ads Manager leverages its social media platforms to facilitate targeted advertising, brand promotion, 
                  and audience engagement through advanced data analytics, creativity and audience segmentation.`,
    isConnected: false,
    tagline: "PREMIUM",
  },
  {
    name: "Shopify Ads",
    slug: "shopify",
    icon: shopifyIcon,
    description: `Shopify is a Canadian e-commerce company that provides a platform for businesses to set up and manage online stores.`,
    isConnected: false,
    tagline: "PREMIUM",
  },
  {
    name: "Tiktok Ads",
    slug: "tiktok",
    icon: tiktokIcon,
    description: `TikTok Ads provides a powerful platform for brands to reach and engage a global audience through short-form videos. 
                It offers diverse ad formats, precise audience targeting, and performance tracking to maximize campaign effectiveness.`,
    isConnected: false,
    tagline: "PREMIUM",
  },
  {
    name: "Snapchat Ads",
    slug: "snapchat",
    icon: snapchatIcon,
    description: `Snapchat Ads provide a way for businesses to reach a younger audience through engaging video ads.`,
    isConnected: false,
    tagline: "PREMIUM",
  },
  {
    name: "LinkedIn Ads",
    slug: "linkedin",
    icon: linkedinIcon,
    description: `LinkedIn Ads provide a platform for businesses to target professionals through engaging ad formats.`,
    isConnected: false,
    tagline: "PREMIUM",
  },
  {
    name: "Taboola Ads",
    slug: "taboola",
    icon: taboolaIcon,
    description: `Taboola is the world's leading discovery and native advertising platform. Connect your Taboola account to manage campaigns and track performance directly from OneBotAds.`,
    isConnected: false,
    tagline: "PREMIUM",
  },
  {
    name: "Shopify OAuth Ads",
    slug: "shopify-oauth",
    icon: shopifyIcon, // Reusing Shopify icon, or use a new one if desired
    description: `Shopify OAuth Ads integrates with your Shopify store via OAuth to manage advertising campaigns directly from your store’s data.`,
    isConnected: false,
    tagline: "PREMIUM",
  },
];

export const allAdConfigurations = {
  googleAdsConfiguration: {
    name: "Google Ads",
    authUrl: `${BASE_URL}/api/ads-auth/google`,
    slug: "google",
    permissions: [
      {
        detail: "Manage Search campaigns",
        isAllowed: true,
      },
      {
        detail: "Manage Performance Max campaigns",
        isAllowed: true,
      },
      {
        detail: "Perform keyword analysis",
        isAllowed: true,
      },
    ],
  },

  metaAdsConfiguration: {
    name: "Meta Ads",
    authUrl: `${BASE_URL}/api/ads-auth/meta`,
    slug: "meta",
    permissions: [
      {
        detail: "Create campaigns",
        isAllowed: true,
      },
      {
        detail: "Manage ads",
        isAllowed: true,
      },
      {
        detail: "Fetch metrics and ads reports",
        isAllowed: true,
      },
    ],
  },

  shopifyAdsConfiguration: {
    name: "Shopify Ads",
    authUrl: null,
    slug: "shopify",
    permissions: [
      {
        detail: "Read and update products",
        isAllowed: true,
      },
      {
        detail: "Read orders",
        isAllowed: true,
      },
      {
        detail: "Remove all your information",
        isAllowed: false,
      },
    ],
  },
  tiktokAdsConfiguration: {
    name: "Tiktok Ads",
    authUrl: `${BASE_URL}/api/ads-auth/tiktok`,
    slug: "tiktok",
    permissions: [
      {
        detail: "Create and manage ad campaigns",
        isAllowed: true,
      },
      {
        detail: "Access audience insights and analytics",
        isAllowed: true,
      },
      {
        detail: "Optimize ads using AI-driven recommendations",
        isAllowed: true,
      },
    ],
  },

  snapchatAdsConfiguration: {
    name: "Snapchat Ads",
    authUrl: `${BASE_URL}/api/ads-auth/snapchat`,
    slug: "snapchat",
    permissions: [
      {
        detail: "Manage Snapchat campaigns",
        isAllowed: true,
      },
      {
        detail: "Analyze audience insights",
        isAllowed: true,
      },
    ],
  },
  linkedinAdsConfiguration: {
    name: "LinkedIn Ads",
    authUrl: `${BASE_URL}/api/ads-auth/linkedin`,
    slug: "linkedin",
    permissions: [
      {
        detail: "Manage LinkedIn Ad Campaigns",
        isAllowed: true,
      },
      {
        detail: "Access audience analytics",
        isAllowed: true,
      },
    ],
  },
  taboolaAdsConfiguration: {
    name: "Taboola Ads",
    authUrl: null,
    slug: "taboola",
    permissions: [
      { detail: "Manage Taboola campaigns", isAllowed: true },
      { detail: "Pause / resume campaigns", isAllowed: true },
      { detail: "Fetch campaign performance metrics", isAllowed: true },
    ],
  },
  shopifyOAuthAdsConfiguration: {
    // New configuration
    name: "Shopify OAuth Ads",
    authUrl: `${BASE_URL}/api/ads-auth/shopify-oauth-ads`, // Base URL, shop name will be appended
    slug: "shopify-oauth",
    permissions: [
      { detail: "Manage Shopify ad campaigns", isAllowed: true },
      { detail: "Access store data for ad targeting", isAllowed: true },
      { detail: "Fetch ad performance metrics", isAllowed: true },
    ],
  },
};

export const isOAuthFlow = (platformName) => {
  return [
    allAdConfigurations.googleAdsConfiguration.slug,
    allAdConfigurations.metaAdsConfiguration.slug,
    allAdConfigurations.tiktokAdsConfiguration.slug,
    allAdConfigurations.snapchatAdsConfiguration.slug,
    allAdConfigurations.linkedinAdsConfiguration.slug,
    allAdConfigurations.shopifyOAuthAdsConfiguration.slug,
  ].includes(platformName);
};
